module.exports = __webpack_public_path__ + "img/layer2Blobs-PinkPurple.043257ee.svg";